const PRE_PROPOSAL_ALTERAR_SYNC_DEBOUNCE_MS = 450;

let preProposalAlterarSyncTimer: ReturnType<typeof setTimeout> | null = null;

export const cancelPreProposalAlterarSyncDebounce = () => {
  if (preProposalAlterarSyncTimer) {
    clearTimeout(preProposalAlterarSyncTimer);
    preProposalAlterarSyncTimer = null;
  }
};

export const schedulePreProposalAlterarSync = (sync: () => void) => {
  cancelPreProposalAlterarSyncDebounce();
  preProposalAlterarSyncTimer = setTimeout(() => {
    preProposalAlterarSyncTimer = null;
    sync();
  }, PRE_PROPOSAL_ALTERAR_SYNC_DEBOUNCE_MS);
};
